// extracted by mini-css-extract-plugin
export default {"input":"Y--z","button":"Z--z","selected":"_--z","unavailable":"a_-z","oos":"b_-z","paperCutDisabledOverlay":"c_-z","image":"d_-z"};